import React from "react";
import "./index.css";
import { Language } from "../../types";
import { useContextProvider } from "../../context";
import { feedbackData } from "./data";
import personIcon from "./person.png";
import starIcon from "./star.png";

const dict = {
  title: {
    [Language.English]: "Reviews",
    [Language.Spanish]: "Reseñas",
    [Language.Russian]: "Отзывы",
    [Language.Ukrainian]: "Відгуки",
  },
};

export const Reviews: React.FC = () => {
  const { language } = useContextProvider();
  return (
    <section className="Reviews">
      <div className="Reviews-container">
        <h2>{dict.title[language]}</h2>
        {feedbackData.map((feedback) => (
          <article key={feedback.id}>
            <div className="Reviews-author">
              <img alt="person icon" height={30} width={30} src={personIcon} />
              <span>{feedback.sign[language]}</span>
            </div>
            <div>
              <img alt="rating star" height={25} width={25} src={starIcon} />
              <img alt="rating star" height={25} width={25} src={starIcon} />
              <img alt="rating star" height={25} width={25} src={starIcon} />
              <img alt="rating star" height={25} width={25} src={starIcon} />
              <img alt="rating star" height={25} width={25} src={starIcon} />
            </div>
            <div className="Reviews-content">
              <q>{feedback.text[language]}</q>
            </div>
            <div className="Reviews-date">{feedback.date}</div>
          </article>
        ))}
      </div>
    </section>
  );
};
